import { makeSearchParams } from '@monjin/data';
import { TimeZone } from '@monjin/data/model/Profile';
import { checkArray } from '@monjin/primer/util';

import { Country, EmployerSuggest, IndustrySuggest, RoleSuggest, SkillSuggestion, MasterData } from '../model/suggestions';
import { fetchBody, makeGet } from './util';

// Pulls list of industries
export function suggestIndustries(): Promise<IndustrySuggest[]> {

    const url = `/__/a/22/1/1/1/sgt/Industry`;

    const request = makeGet(url);

    return fetchBody(request)
        .then(parseIndustrySuggestion);
}

function parseIndustrySuggestion(response: any): IndustrySuggest[] {

    const parsedData = response ? response.map((item) => {

        const suggestion: IndustrySuggest = {
            value: item.name,
            id: item.id
        };

        return suggestion;
    }) : [];

    return parsedData;
}

export function suggestJobRoles(): Promise<RoleSuggest[]> {

    const url = `/__/a/22/1/1/1/sgt/JFRole`;
    const request = makeGet(url);

    return fetchBody(request)
        .then(parseJobRoles);
}

function parseJobRoles(response: any): RoleSuggest[] {

    const parsedData = response
        ? response.map((x) => ({ id: x.id, value: x.name, jobFunctionId: x.jobFunctionId }))
        : [];

    return parsedData;
}

export function suggestCountries(): Promise<Country[]> {
    const url = `/__/a/22/1/2/1/mtr/Country`;

    return fetchBody(makeGet(url))
        .then(parseCountries);
}

function parseCountries(countries: any): Country[] {
    return countries.map((country) => {
        return {
            id: country.id,
            value: country.name,
            dialCode: country.code
        };
    });
}

export function suggestTimeZones(): Promise<TimeZone[]> {
    const url = `/__/a/22/1/1/1/mtr/timezone`;

    return fetchBody(makeGet(url))
        .then(parseTimeZones);
}

function parseTimeZones(response: any): TimeZone[] {
    return response.map((timeZone) => {
        return {
            id: timeZone.id,
            name: timeZone.label,
            offset: timeZone.offset
        };
    });
}

export function fetchSkills(q: string = '', isActive: boolean = true, isCustom: boolean = false): Promise<SkillSuggestion[]> {
    let filterQuery = `isActive eq ${isActive} and isCustom eq ${isCustom}`;

    if (q) {
        filterQuery += ` and contains(name,'${q}')`;
    }

    const params = makeSearchParams({
        $filter: filterQuery
    }).toString();


    const url = `/_/a/22/1/1/1/sgt/Skill?${params}`;

    const request = makeGet(url);

    return fetchBody(request)
        .then(parseSkills);
}

function parseSkills(response: any): SkillSuggestion[] {
    return checkArray(response).map((x) => {
        return {
            id: x.id, // Skill alias Id.
            skillId: x.skillId,
            name: x.name
        };
    });
}

export function suggestEmployerTypeAhead(searchString: string, isActive: boolean = true, isCustom: boolean = false)
    : Promise<EmployerSuggest[]> {

    const params = makeSearchParams({
        $filter: `contains(tolower(Name),tolower('${searchString}')) and isActive eq ${isActive} and isCustom eq ${isCustom}`,
        sort: 'name'
    }).toString();

    const url = `/_/a/22/1/1/1/sgt/Organization?${params}`;
    const request = makeGet(url);

    return fetchBody(request)
        .then(parseEmployers);
}

function parseEmployers(response: any): EmployerSuggest[] {
    const parsedData = checkArray(response).map((x) => {
        return {
            aliasId: x.organizationId,
            id: x.id,
            name: x.name
        };
    });

    return parsedData;
}
